const ASADO_BASE_URLS = {
  dev: 'https://asado.fff-dev.com',
  prod: 'https://asado.fabfitfun.com',
};

export { ASADO_BASE_URLS };
